import type { Block } from '@hump/shared-types';
import type { DisplayMode } from '../../stores/reader';
import { useBreakpoint } from '../../lib/hooks/use-breakpoint';
import { BlockView } from './BlockView';

interface ModeRendererProps {
  blocks: Block[];
  mode: DisplayMode;
  docId?: string;
  onAskAi?: (blockId: string) => void;
}

export function ModeRenderer({ blocks, mode, docId, onAskAi }: ModeRendererProps) {
  // 9.13 工作台三布局：desktop / tablet / mobile
  const device = useBreakpoint();

  if (blocks.length === 0) return null;

  switch (mode) {
    case 'bilingual': {
      // desktop（≥1280px）→ 左右双列
      // tablet（768-1279px）→ 上下单列
      // mobile（<768px）→ 单列
      if (device === 'desktop') {
        return (
          <div className="grid grid-cols-2 gap-4">
            <div>
              {blocks.map((b) => (
                <BlockView key={`o-${b.id}`} block={b} showTranslation={false} docId={docId} onAskAi={onAskAi} />
              ))}
            </div>
            <div>
              {blocks.map((b) => (
                <BlockView key={`t-${b.id}`} block={b} showTranslation={true} docId={docId} onAskAi={onAskAi} />
              ))}
            </div>
          </div>
        );
      }
      // tablet / mobile：单列（原文 + 译文上下排列）
      return (
        <div className="grid grid-cols-1 gap-4">
          <div>
            {blocks.map((b) => (
              <BlockView key={`o-${b.id}`} block={b} showTranslation={false} docId={docId} onAskAi={onAskAi} />
            ))}
          </div>
          <div>
            {blocks.map((b) => (
              <BlockView key={`t-${b.id}`} block={b} showTranslation={true} docId={docId} onAskAi={onAskAi} />
            ))}
          </div>
        </div>
      );
    }

    case 'mixed':
      return (
        <div>
          {blocks.map((b) => (
            <BlockView key={b.id} block={b} showTranslation={true} docId={docId} onAskAi={onAskAi} />
          ))}
        </div>
      );

    case 'original':
      return (
        <div>
          {blocks.map((b) => (
            <BlockView key={b.id} block={b} showTranslation={false} docId={docId} onAskAi={onAskAi} />
          ))}
        </div>
      );

    case 'translation':
      return (
        <div>
          {blocks
            .filter((b) => b.translation)
            .map((b) => (
              <div key={b.id} className="py-2">
                <p className="text-charcoal dark:text-charcoal-light">{b.translation}</p>
              </div>
            ))}
        </div>
      );
  }
}
